import { render, staticRenderFns } from "./shanghuSearchInfo.vue?vue&type=template&id=42e5f367&scoped=true&"
import script from "./shanghuSearchInfo.vue?vue&type=script&lang=js&"
export * from "./shanghuSearchInfo.vue?vue&type=script&lang=js&"
import style0 from "./shanghuSearchInfo.vue?vue&type=style&index=0&id=42e5f367&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e5f367",
  null
  
)

export default component.exports